const initialValues = {
  code: '',
};

export default initialValues;
